import { Link } from "react-router-dom";
import { navItems, site, seasonFilters } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 border-t border-primary-900/60 mt-auto pb-16 lg:pb-0">
      <div className="px-5 md:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950 font-heading font-bold text-lg">
                T4
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading font-semibold text-foreground-950 tracking-wide">{site.name}</span>
                <span className="font-label text-[10px] tracking-[0.28em] text-primary-300 mt-1">TABOO IV</span>
              </div>
            </div>
            <p className="mt-4 text-sm text-primary-200 leading-relaxed max-w-md">{site.intro}</p>
            <p className="mt-3 text-xs text-primary-400">{site.contactEmail}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm tracking-widest text-foreground-900 uppercase mb-4">
              <span className="hover:text-accent-400 transition-colors">站内导航</span>
            </h4>
            <ul className="space-y-2.5">
              {navItems.map((item) => (
                <li key={item.key}>
                  <Link to={item.path} className="text-sm text-primary-300 hover:text-accent-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm tracking-widest text-foreground-900 uppercase mb-4">
              <span className="hover:text-accent-400 transition-colors">剧集分季</span>
            </h4>
            <ul className="space-y-2.5">
              {seasonFilters.filter((s) => s.value > 0).map((s) => (
                <li key={s.value}>
                  <Link
                    to={`/episodes?season=${s.value}`}
                    className="text-sm text-primary-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {s.label} 章节
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900/70 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-primary-400">© {year} {site.name} · 影视专题内容站</p>
          <p className="text-xs text-primary-400 max-w-2xl sm:text-right leading-relaxed">{site.footerNote}</p>
        </div>
      </div>
    </footer>
  );
}